var _path, _path2, _rect, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "57px",
    width: "57px",
    viewBox: "0 0 113.4 115",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    fill: "#FFDE44",
    d: "m25.5 24.6c17.9-18.2 47.1-17.7 64.2 1.5 15.4 17.3 15 44.3-0.8 61.4-13.6 14.6-34.2 18-50.9 10.2-1.3-0.6-2.9-0.7-4.3-0.3l-13.3 4.4c-4.4 1.5-8.7-2.6-7.5-7.2l4.3-17c-8.7-17.1-5.9-38.7 8.3-53z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "#202C56",
    d: "m59.2 79.4c-2.7 0-5.4-0.4-8-1.2-7.2-2.1-13.2-6.9-16.8-13.5-7.1-13-2.7-29.2 9.6-37.1l-0.9-1.8c-0.5-1-0.2-2.2 0.8-2.7s2.2-0.2 2.7 0.8l2.8 5.2-1.8 1c-11.7 6.3-16 21-9.7 32.7 3.1 5.7 8.2 9.8 14.3 11.6 6.2 1.8 12.7 1.1 18.3-1.9 1-0.5 2.2-0.2 2.7 0.8s0.2 2.2-0.8 2.7c-4 2.2-8.6 3.4-13.2 3.4z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    fill: "#202C56",
    x: 56.9,
    y: 75.3,
    width: 4,
    height: 11.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "#202C56",
    d: "m69.2 88.4h-19c-1.1 0-2-0.9-2-2s0.9-2 2-2h19c1.1 0 2 0.9 2 2s-0.9 2-2 2zm-9.7-16.5c-7.7 0-15.2-4.4-18.7-11.8v-0.1c-2.3-5-2.6-10.6-0.7-15.7 1.9-5.2 5.6-9.3 10.6-11.7 6.5-3 13.9-2.6 19.9 1.3 0.9 0.6 1.2 1.8 0.6 2.8-0.6 0.9-1.8 1.2-2.8 0.6-4.8-3.1-10.8-3.5-16-1-4 1.9-7 5.2-8.5 9.4s-1.3 8.7 0.6 12.7v0.1c3.9 8.3 13.8 11.8 22.1 7.9 4.2-2 7.2-5.5 8.6-9.6-1 0.8-2.1 1.4-3.4 1.8-2.8 0.9-5.8 0.7-8.5-0.6-2.6-1.3-4.6-3.6-5.5-6.4-0.3-1.1 0.2-2.2 1.3-2.5s2.2 0.2 2.5 1.3c0.6 1.8 1.8 3.3 3.5 4.1 1.7 0.9 3.6 1 5.4 0.4 3.7-1.2 5.7-5.2 4.5-8.9-0.1-0.2-0.1-0.4-0.1-0.6-0.2-1 0.3-2 1.3-2.3 1-0.4 2.2 0.1 2.6 1.2 3.8 10-0.8 21.3-10.5 25.9-2.9 1.1-5.9 1.7-8.8 1.7zm-1.8-24.9c-0.8 0-1.5-0.4-1.8-1.2-0.6-1.3-0.7-2.8-0.1-4.2s1.8-2.6 3.3-3.2c3-1.2 6.4 0.1 7.7 2.9 0.5 1 0 2.2-1 2.7s-2.2 0-2.7-1c-0.4-0.8-1.6-1.2-2.6-0.8-0.5 0.2-0.9 0.5-1 1-0.1 0.2-0.2 0.6 0 1 0.5 1 0 2.2-1 2.7-0.2 0.1-0.5 0.1-0.8 0.1z"
  })));
};
export default SvgLogo;